/** @format */
import { ChangeDetectionStrategy, Component, Inject, Input, OnInit, Optional, ViewEncapsulation } from '@angular/core';
import { CourseUnit, CourseUnitSelection, OtmId } from 'common-typescript/types';
import { Observable, of, take } from 'rxjs';
import { AppErrorHandler } from '../../error-handler/app-error-handler';
import { PLAN_ACTIONS_SERVICE_INJECTION_TOKEN, PlanActionsService } from '../../plan/plan-actions-service/plan-actions.service';
import { CourseUnitEntityService } from '../../service/course-unit-entity.service';

@Component({
    selector: 'sis-completion-method-box',
    templateUrl: './completion-method-box.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class CompletionMethodBoxComponent implements OnInit {
    @Input({ required: true }) courseUnit: CourseUnit;
    @Input({ required: true }) courseUnitSelection: CourseUnitSelection;

    courseUnit$: Observable<CourseUnit>;
    originalCourseUnit: CourseUnit;

    ngOnInit(): void {
        this.originalCourseUnit = this.courseUnit;
        if (this.courseUnitSelection.gradeRaiseAttempt && this.courseUnitSelection.gradeRaiseAttempt.courseUnitId !== this.courseUnit.id) {
            this.courseUnit$ = this.getCourseUnit(this.courseUnitSelection.gradeRaiseAttempt.courseUnitId);
        } else {
            this.courseUnit$ = of(this.courseUnit);
        }
    }

    constructor(
        @Optional() @Inject(PLAN_ACTIONS_SERVICE_INJECTION_TOKEN) private readonly planActionsService: PlanActionsService,
        private readonly courseUnitEntityService: CourseUnitEntityService,
        private readonly appErrorHandler: AppErrorHandler,
    ) {}
    hasCompletionMethods(courseUnit: CourseUnit): boolean {
        return courseUnit?.completionMethods?.length > 0;
    }
    isCompletionMethodSelectionMissing() {
        return !this.courseUnitSelection?.completionMethodId;
    }
    hasOneCompletionMethodSelected(courseUnit: CourseUnit) {
        return courseUnit?.completionMethods?.filter(method => method.studyType === 'DEGREE_STUDIES').length === 1;
    }

    getCompletionMethodIndex(courseUnit: CourseUnit): number {
        const index = courseUnit?.completionMethods
            .map(completionMethod => completionMethod.localId)
            .indexOf(
                this.courseUnitSelection?.gradeRaiseAttempt
                    ? this.courseUnitSelection.gradeRaiseAttempt.completionMethodId
                    : this.courseUnitSelection?.completionMethodId,
            );
        return index >= 0 ? index + 1 : undefined;
    }

    openSelectCompletionMethodModal() {
        this.planActionsService?.openSelectCompletionMethodModal(this.originalCourseUnit);
    }

    completionMethodNotification(courseUnit: CourseUnit) {
        if (!this.hasCompletionMethods(courseUnit)) {
            return { type: 'no-methods' };
        }

        if (this.isCompletionMethodSelectionMissing() && !this.courseUnitSelection.gradeRaiseAttempt) {
            return { type: 'missing-selection' };
        }

        if (this.hasOneCompletionMethodSelected(courseUnit)) {
            return { type: 'single-selected' };
        }

        return { type: 'multiple-selected' };
    }

    getCourseUnit(courseUnitId: OtmId) {
        return this.courseUnitEntityService.getById(courseUnitId).pipe(take(1), this.appErrorHandler.defaultErrorHandler());
    }
}
